import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3351d18a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3351d18a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3351d18a')) {
      api.createRecord('3351d18a', component.options)
    } else {
      api.reload('3351d18a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3351d18a&scoped=true", function () {
      api.rerender('3351d18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/verify/lock/index.vue"
export default component.exports